/** The rows the live queries in `shared/queries.ts` produce. A `sub` arrives as an array, a
 *  `countAs` as a number. */
import type { IssuePriority, IssueStatus } from '../shared/schema.ts';

export interface Project { id: string; name: string; key: string }
export interface User { id: string; name: string }
export interface Tag { id: string; issueId: string; name: string }
export interface Comment { id: string; issueId: string; authorId: string; body: string; createdAt: number; author?: User[] }

interface IssueBase {
  id: string; projectId: string; title: string; status: IssueStatus; priority: IssuePriority;
  ownerId: string; createdAt: number; updatedAt: number;
  project?: Project[]; owner?: User[]; tags?: Tag[];
}
/** A list row or board card. */
export interface IssueCard extends IssueBase { commentCount: number }
/** The detail pane: the whole thread, oldest first. */
export interface IssueDetail extends IssueBase { comments?: Comment[] }
/** An activity-feed row: a comment with its author and the issue it is on. */
export interface FeedItem extends Comment {
  issue?: (Pick<IssueBase, 'id' | 'title' | 'status'> & { project?: Project[] })[];
}

export const nameOf = (users: User[] | undefined, fallback: string) => users?.[0]?.name ?? fallback;
